import React from 'react';
import { History } from 'history';
import { InputDate, InputMoney, InputPicklist } from '../../components';
import BaseCreate from '../base/base-create.component'; 
import Model from './coabalance-model';  //editable..
import CoaPicklist from '../coa/coa-picklist.component';
                
interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class CoabalanceCreate extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
        this.onChange = this.onChange.bind(this);
    }
    
    private onLoadCoa = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'coa': data?.id, 'coaCaption': data?.name || ''  }  });
    }
    
    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..          
            <BaseCreate history={this.props.history} 
                model={Model} datarow={this.state.datarow} onError={this.onError}>               
          
                <InputDate name='balancedate' label='Date' value={this.state.datarow.balancedate} error={this.state.errors?.balancedate} onChange={this.onChange} />
                <InputMoney name='value' label='Value' value={this.state.datarow.value} error={this.state.errors?.value} onChange={this.onChange} />
                <InputPicklist name='coa' label='COA' value={this.state.datarow.coa} caption={this.state.datarow.coaCaption} error={this.state.errors?.coa} onChange={this.onChange} >
                    <CoaPicklist currentId={this.state.datarow.coa} onLoad={this.onLoadCoa}/>
                </InputPicklist>         
            </BaseCreate>
        );
    }     
     
}